import React from 'react';
import { Switch } from '@heroui/react';
import { cn } from '../utils';

export interface SwitchRowProps {
  label: React.ReactNode;
  description?: React.ReactNode;
  isSelected: boolean;
  onChange: (value: boolean) => void;
  isDisabled?: boolean;
  className?: string;
}

export const SwitchRow: React.FC<SwitchRowProps> = ({
  label,
  description,
  isSelected,
  onChange,
  isDisabled,
  className
}) => (
  <Switch
    isSelected={isSelected}
    onChange={onChange}
    isDisabled={isDisabled}
    size="sm"
    className={cn('w-full', className)}>
    <Switch.Content className="flex w-full items-center justify-between gap-3">
      <span className="min-w-0 text-sm">
        {label}
        {description && <span className="mt-1 block text-xs text-default-500">{description}</span>}
      </span>
      <Switch.Control className="shrink-0">
        <Switch.Thumb />
      </Switch.Control>
    </Switch.Content>
  </Switch>
);

SwitchRow.displayName = 'SwitchRow';
